import { getAction } from './requests'

/**
 * 查询交易大厅项目公告列表
 * @param {Object} params - 查询参数
 * @param {number} [params.pageNum] - 页码
 * @param {number} [params.pageSize] - 每页数量
 * @param {string} [params.searchValue] - 搜索关键词
 * @param {string} [params.announcementName] - 公告名称
 * @param {string} [params.announcementNo] - 公告编号
 * @param {string} [params.bidResultId] - 竞价结果ID
 * @param {string} [params.delFlag] - 删除标记
 * @param {string} [params.projectId] - 正式挂牌项目ID
 * @param {string} [params.projectName] - 转让标的名称
 * @param {string} [params.listingStartTime] - 挂牌开始时间
 * @param {string} [params.listingEndTime] - 挂牌截止时间
 * @param {number} [params.listingPrice] - 挂牌价
 * @param {string} [params.dealDate] - 成交日期
 * @param {number} [params.dealPrice] - 成交价
 * @param {string} [params.transferorDeptName] - 甲方单位名称
 * @param {string} [params.transfereeDeptName] - 乙方单位名称
 * @returns {Promise}
 */
export function getAnnouncementList(params) {
  return getAction('/trade/hall/announcement/list', params)
}

/**
 * 查询交易大厅项目公告详情
 * @param {string} id - 公告ID
 * @returns {Promise}
 */
export function getAnnouncementDetail(id) {
  return getAction(`/trade/hall/announcement/${id}`)
}

/**
 * 查询项目大厅列表
 * @param {Object} params - 查询参数
 * @param {number} [params.pageNum] - 页码
 * @param {number} [params.pageSize] - 每页数量
 * @param {string} [params.searchValue] - 搜索关键词
 * @param {string} [params.projectName] - 项目名称
 * @param {string} [params.projectType] - 项目类型
 * @param {string} [params.projectStatus] - 项目状态（listing挂牌中/applying报名中/bidding竞价中/dealed已成交/terminated已终止）
 * @param {string} [params.sourceType] - 来源类型（formal正式挂牌/intention意向挂牌）
 * @returns {Promise}
 */
export function getProjectHallList(params) {
  return getAction('/trade/hall/list', params)
}

/**
 * 查询项目大厅详情
 * @param {string} sourceType - 来源类型（formal/intention）
 * @param {string} id - 项目ID
 * @returns {Promise}
 */
export function getProjectHallDetail(sourceType, id) {
  return getAction(`/trade/hall/${sourceType}/${id}`)
}
